export const higherFloorVasStatus = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT'
};
